import React from 'react';
import { connect } from 'react-redux';
import { Progress } from 'semantic-ui-react';

import './ProgressBarCompareAds.css';

const ProgressBarCompareAds = (props) => {
  const renderInfoTotals = () => {
    const qcAdsProgress = props[`${props.keySection}Ads`].qcProcess;
    let totalAds = 0;
    let totalQC = 0;
    Object.keys(qcAdsProgress).forEach((key) => {
      totalAds += qcAdsProgress[key].totalAds;
      totalQC += qcAdsProgress[key].totalQC;
    });
    return (
      <span className="total-ads-qc">{`${totalQC}/${totalAds}`}</span>
    );
  };
  if (props[`${props.keySection}Ads`]) { 
    return (
      <div className={props.className}>
        {renderInfoTotals()}
        <Progress percent={props[`${props.keySection}Ads`].generalQCProgress ? props[`${props.keySection}Ads`].generalQCProgress : 0} color="green" progress />
      </div>
    );
  }
  return null;
};

const mapStateToProps = (state) => {
  const newProps = Object.assign({}, {
    ...state.adComparer,
  });
  return newProps;
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(
  ProgressBarCompareAds
);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/ProgressBarCompareAds.js